export default __webpack_public_path__ + "static/media/Bld_H1.a2e88cd8.mp3";